module.exports = __webpack_public_path__ + "images/img-2MJxoXF.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/growth.jpg
// module id = 1994
// module chunks = 0